// src/Components/NotificationBell.js
import React, { useState, useRef, useEffect } from "react";
import { useNotifications } from "../../APIContext/NotificationContext";
import "./style.css";

function NotificationBell() {
  const { notifications, unreadCount, markAsRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen((prev) => !prev);

  // ✅ Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if dropdown is open and click is outside of the component
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // cleanup listener on unmount
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="notification-wrapper" ref={dropdownRef}>
      <button className="notification-button" onClick={toggleDropdown}>
        🔔
        {unreadCount > 0 && (
          <span className="notification-count">{unreadCount}</span>
        )}
      </button>

      {open && (
        <div className="notification-dropdown">
          {notifications.length === 0 ? (
            <div className="notification-empty">No notifications</div>
          ) : (
            notifications.map((n) => (
              <div
                key={n.id}
                className={`notification-item ${n.is_read ? "read" : "unread"}`}
                onClick={() => markAsRead(n.id)}
              >
                <div className="notification-title black-text-clip">
                  {n.notification?.title || "Notification"}
                </div>
                <div className="notification-message black-text-clip">
                  {n.notification?.message || ""}
                </div>
                <div className="notification-time">
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default NotificationBell;
